import { extractGenericOptions } from '../utils/genericOptionsUtils'
const useCadsData = (landingContext, pageContext) => {
  const prospectGN = landingContext.offer && landingContext.offer.prospect.genericOptions
  const vinDecodeGN = landingContext.vinResults && landingContext.vinResults.genericOptions
  const isEditOffer = landingContext.offer && !landingContext.offer.isExpired
  const isResubmitOffer = landingContext.offer && landingContext.offer.isExpired
  const isVinDecode = landingContext.vinResults && !landingContext.offer

  let genericOptionsRaw = []
  if (isEditOffer) {
    genericOptionsRaw = prospectGN
  } else {
    genericOptionsRaw = vinDecodeGN
  }

  const genericOptionsProcessed = extractGenericOptions(genericOptionsRaw)
  landingContext.setGenericOptions(genericOptionsProcessed, isEditOffer)
}

const storeGenericOptions = genericOptions => {}

export { useCadsData, storeGenericOptions }
